import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '../List';
import Preloader from '../Preloader';
import ClientsListItem from '../ClientsListItem';

const ClientsRecentList = ({ classes, clients, onClientSelect, loading, isRecentList }) => {
  return (
    <Fragment>
      {loading && <Preloader />}
      <List
        subheader={
          isRecentList && (
            <ListSubheader disableGutters disableSticky component="div" className={classes.title}>
              Recent Searches
            </ListSubheader>
          )
        }
      >
        {clients.map((client) => {
          return (
            <ClientsListItem
              onClick={() => onClientSelect(client, true)}
              client={client}
              key={client.profileId}
              data-testid="recent-list-details"
              showBagIndicator
            />
          );
        })}
      </List>
    </Fragment>
  );
};

ClientsRecentList.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      profileId: PropTypes.string,
      conciergeItems: PropTypes.bool,
    }),
  ),
  onClientSelect: PropTypes.func,
  isRecentList: PropTypes.bool,
};

ClientsRecentList.defaultProps = {
  classes: {},
  clients: [],
  onClientSelect: () => {},
  isRecentList: false,
};

export default ClientsRecentList;
